import { Box, FormControl, FormControlLabel, Radio, RadioGroup, Typography } from '@mui/material';

interface CanvasModeSelectorProps {
  mode: 'new' | 'existing';
  hasAvailableCanvases: boolean;
  isSubmitting: boolean;
  onModeChange: (mode: 'new' | 'existing') => void;
}

export const CanvasModeSelector = ({
  mode,
  hasAvailableCanvases,
  isSubmitting,
  onModeChange,
}: CanvasModeSelectorProps) => {
  return (
    <>
      <FormControl component="fieldset">
        <RadioGroup
          value={mode}
          onChange={(e) => onModeChange(e.target.value as 'new' | 'existing')}
          aria-label="Canvas configuration mode"
        >
          <FormControlLabel value="new" control={<Radio />} label="Create new canvas" disabled={isSubmitting} />
          <FormControlLabel
            value="existing"
            control={<Radio />}
            label={
              hasAvailableCanvases
                ? `Use existing canvas (${hasAvailableCanvases ? 'available' : 'none available'})`
                : 'Use existing canvas (create one first in another form)'
            }
            disabled={isSubmitting || !hasAvailableCanvases}
          />
        </RadioGroup>
      </FormControl>

      {!hasAvailableCanvases && (
        <Box sx={{ p: 2, bgcolor: 'info.lighter', borderRadius: 1 }}>
          <Typography variant="body2" color="info.main">
            💡 No existing canvases found in this process module. Create your first canvas below, then you'll be able to
            reuse it in other forms.
          </Typography>
        </Box>
      )}
    </>
  );
};
